var helper;

if (typeof window === `undefined`) {
    helper = {};
} else {
    helper = window;
}

export default helper;